import {
  BarChart,
  List,
  Edit,
  AddAlert,
  Sailing,
  Subtitles,
  Assessment,
  ManageSearch,
  FindInPage,
} from '@mui/icons-material';

import EqualizerIcon from '@material-ui/icons/Equalizer';
import Page_GisPier from '~/containers/Page_Gis/Page_Info/Page_GisPier';
import Page_GisBoat from '~/containers/Page_Gis/Page_Info/Page_GisBoat';

import Page_PlanReport from '~/containers/Page_Gis/Page_Info/Page_Multiple/Page_PlanReport';
import Page_StepReport from '~/containers/Page_Gis/Page_Info/Page_Multiple/Page_StepReport';
import Page_DailyReport from '~/containers/Page_Gis/Page_Info/Page_Multiple/Page_DailyReport';

import Page_WindView from '~/containers/Page_Gis/Page_Info/Page_Single/Page_WindView';
import Page_PerWeek from '~/containers/Page_Gis/Page_Info/Page_Single/Page_PerWeek';
import Page_PerMonth from '~/containers/Page_Gis/Page_Info/Page_Single/Page_PerMonth';
import Page_WindProcess from '~/containers/Page_Gis/Page_Info/Page_Single/Page_WindProcess';
import Page_Single from '~/containers/Page_Gis/Page_Info/Page_Single/Page_WindStore';
import Page_DailyStats from '~/containers/Page_Gis/Page_Info/Page_Multiple/Page_Stats/Page_DailyStats';
import Page_WindInfo from '~/containers/Page_Gis/Page_Info/Page_Multiple/Page_InfoReport/Page_WindInfo';
import EventReminder from '~/containers/Page_Gis/Page_Info/Page_Multiple/Page_EventPage/EventReminder';

export default [
  {
    text: '資料檢視服務',
    icon: BarChart,
    path: 'data',
    detail: [
      // {
      //   text: '基本資料檢視',
      //   icon: Assignment,
      //   detail: [],
      //   path: 'basic_contract_view',
      //   page: null,
      // },
      {
        text: '多風場碼頭系統',
        icon: List,
        detail: [],
        path: 'pier',
        page: Page_GisPier,
      },
      {
        text: '多風場船舶',
        icon: Edit,
        detail: [],
        path: 'boat',
        page: Page_GisBoat,
      },
      {
        text: '多風場工程進度',
        icon: AddAlert,
        detail: [
          {
            text: '工進規劃&實際報表',
            path: 'planReport',
            page: Page_PlanReport,
          },
          {
            text: '各項目階段工進期間&累計報表',
            path: 'stepReport',
            page: Page_StepReport,
          },
          {
            text: '每日進度',
            path: 'dailyReport',
            page: Page_DailyReport,
          }
        ],
        path: 'works_progress',
        page: null,
      },
      {
        text: '單一風場工程進度',
        icon: Sailing,
        detail: [
          {
            text: '單一風場進度綜覽&累計報表',
            path: 'windView',
            page: Page_WindView,
          },
          {
            text: '每週規劃進度',
            path: 'perWeek',
            page: Page_PerWeek,
          },
          {
            text: '每月規劃進度',
            path: 'perMonth',
            page: Page_PerMonth,
          },
          {
            text: '風機點位工進表',
            path: 'windProcess',
            page: Page_WindProcess,
          },
          {
            text: '風機部件儲放情形',
            path: 'storage',
            page: Page_Single,
          },
        ],
        path: 'singWind',
        page: null,
      },
      {
        text: '統計數據',
        icon: Assessment,
        detail: [],
        path: 'dailyStats',
        page: Page_DailyStats,
      },
      {
        text: '指定欄位查詢',
        icon: ManageSearch,
        detail: [],
        path: 'windInfo',
        page: Page_WindInfo,        
      },
      {
        text: '事件提醒檢索',
        icon: FindInPage,
        detail: [],
        path: 'eventReminder',
        page: EventReminder,        
      }
    ],
  },
];
